import { type RecType } from '@/defs/rec'
import { formatFullNumber } from '@/utils/formatUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonFigure } from '../../StatCommon/StatCommonFigure/StatCommonFigure'
import { StatRecDeckTotalTooltip } from '../StatRecDeckTotalTooltip/StatRecDeckTotalTooltip'

type Props = {
  isInView?: boolean
  rec: RecType
  variant?: 'commander'
}

export const StatRecDeckTotalFull = ({ isInView, rec, variant }: Props) => (
  <StatCommonBox
    isInView={isInView}
    label='Decks'
    popover={rec.numDecks !== undefined && <StatRecDeckTotalTooltip rec={rec} variant={variant} />}
  >
    {rec.numDecks !== undefined && <StatCommonFigure>{formatFullNumber(rec.numDecks)}</StatCommonFigure>}
  </StatCommonBox>
)
